import { Message, MessageBox } from 'element-ui'
import util from '@/libs/util.js'
import router from '@/router'
import { AccountLogin } from '@api/sys.login'
import { LoadMenu, initMenu, mHeader, mAside } from '@api/sys.menu'
import store from '@/store/index'
import user from './user'
import { userLogout } from '@api/user/user'
import { getUserPermissionInfo } from '@api/permission/permission'

let permissionMenu = []

let permission = {
  functions: [],
  roles: [],
  interfaces:[],
  isAdmin: false,
  shopId: 0,
}

//拉取权限信息
let fetchPermissionInfo = async () => {

  // 点击登录标识：1点击登录 0非点击登录
  let loginFlag = 0;
  let flag = util.cookies.get("loginFlag");
  if(flag != null && flag != undefined) {
    loginFlag = Number(flag);
  }

    getUserPermissionInfo({loginFlag: loginFlag}).then(async res => {
		if(res != undefined) {
			let userPermissionInfo = res.data
			
			util.cookies.set('preferences', res.data.preferences) //缓存偏好设置
			
			permissionMenu = userPermissionInfo.accessMenus
			
			initMenu(permissionMenu)
			store.commit('d2admin/menu/headerSet', mHeader)
			store.commit('d2admin/menu/asideSet', mAside)
			// // permissionRouter = userPermissionInfo.accessRoutes
			permission.functions = userPermissionInfo.userPermissions
			permission.roles = userPermissionInfo.userRoles
			
			// permission.interfaces = util.formatInterfaces(userPermissionInfo.accessInterfaces) // util 格式化有异常，临时屏蔽
			// console.info(" 权限信息 0： " +userPermissionInfo.isAdmin)
			if(userPermissionInfo.isAdmin == 1){
			  permission.isAdmin =true
			}else{
			  permission.isAdmin = false
			}
			// console.info(" 权限信息 1： " +JSON.stringify(permission))
			permission.isAdmin = userPermissionInfo.isAdmin == 1
			
			//当前用户的店铺id（admin=0）
			permission.shopId = userPermissionInfo.shopId
			// 设置权限信息
			store.commit('d2admin/permission/set', permission)
			
			util.cookies.remove("loginFlag");
		}
      
    }).catch((err) => {
      console.log('err: ', err)
    })

}


export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} param context
     * @param {Object} param userName {String} 用户账号
     * @param {Object} param password {String} 密码
     * @param {Object} param route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login({ dispatch }, {
      userName = '',
      password = '',
    } = {}) {
      return new Promise((resolve, reject) => {
        // 开始请求登录接口
        AccountLogin({
          userName,
          password,
        })
          .then(async res => {
            // 设置 cookie 一定要存 uuid 和 token 两个 cookie
            // 整个系统依赖这两个数据进行校验和存储
            // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
            // token 代表用户当前登录状态 建议在网络请求中携带 token
            // 如有必要 token 需要定时更新，默认保存一天
            // util.cookies.set('uuid', res.uuid)
            // util.cookies.set('token', res.token)
            // console.log(JSON.stringify(res))
            util.cookies.set('uuid', userName + '-uuid')
            util.cookies.set('token', res.data.token)
			      util.cookies.set('democracy', res.data.token)
            // 点击登录标识：1点击登录 0非点击登录
            util.cookies.set('loginFlag', 1)

            // util.cookies.set('token', res.data.access_token)
            // 设置 vuex 用户信息
            await dispatch('d2admin/user/set', {
              // name: res.name
              name: userName
            }, { root: true })
            // 用户登录后从持久化数据加载一系列的设置
            await dispatch('load')
            // 结束
            resolve()
          })
          .catch(err => {
            console.log('err: ', err)
            reject(err)
          })
      })
    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} param context
     * @param {Object} param confirm {Boolean} 是否需要确认
     */
    logout({ commit, dispatch }, { confirm = false } = {}) {
      /**
       * @description 注销
       */
      async function logout() {
		  //后台登录信息注销
		  userLogout().then(res => {
			  // 删除cookie
			  util.cookies.remove('token')
			  util.cookies.remove('uuid')
			  util.cookies.remove('client')
			  util.cookies.remove('democracy')
			  // 清空 vuex 用户信息
			  dispatch('d2admin/user/set', {}, { root: true })
			  
			  // 跳转路由
			  router.push({
			    name: 'login'
			  })
		  });
      }
	  
      // 判断是否需要确认
      if (confirm) {
        commit('d2admin/gray/set', true, { root: true })
		
        MessageBox.confirm('注销当前账户吗？打开的标签页和用户设置将会被保存。', '确认操作', {
          confirmButtonText: '确定注销',
          cancelButtonText: '放弃',
          type: 'warning'
        })
          .then(() => {
            commit('d2admin/gray/set', false, { root: true })
            logout()
          })
          .catch(() => {
            commit('d2admin/gray/set', false, { root: true })
            Message({
              message: '放弃注销用户'
            })
          })
      } else {
        logout()
      }
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} state vuex state
     */
    load({ dispatch }) {
      return new Promise(async resolve => {
		  await fetchPermissionInfo();
		  
        // DB -> store 加载用户名
        await dispatch('d2admin/user/load', null, { root: true })
        // DB -> store 加载主题
        await dispatch('d2admin/theme/load', null, { root: true })
        // DB -> store 加载页面过渡效果设置
        await dispatch('d2admin/transition/load', null, { root: true })
        // DB -> store 持久化数据加载上次退出时的多页列表
        await dispatch('d2admin/page/openedLoad', null, { root: true })
        // DB -> store 持久化数据加载侧边栏折叠状态
        await dispatch('d2admin/menu/asideCollapseLoad', null, { root: true })
        // DB -> store 持久化数据加载全局尺寸
        await dispatch('d2admin/size/load', null, { root: true })
        // end
        //const token = util.cookies.get('token')
       //if (token && token !== 'undefined') {
          //let name = user.state.info.name
          //获取菜单
          // LoadMenu({loginName:name}).then(async res => {
          //   let menu = res["data"]
          //   // let menu = res
          //   initMenu(menu)
          //   store.commit('d2admin/menu/headerSet', mHeader)
          //   store.commit('d2admin/menu/asideSet', mAside)
          // }).catch((err) => {
          //   console.log('err: ', err)
          // })

          //拉取权限信息,包括权限过滤后的角色编码集合，功能编码集合，接口信息集合，菜单列表，路由列表，以及是否系统管理员标识
          

        //}
        resolve()
      })
    }
  }
}
